import React, { Fragment, useEffect, useRef } from 'react';
import './StandardPhoneNumber.scss';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { ValidationObj } from '../../../types/interface';
import { capitalizeFirstLetter } from 'utils/helpers';

interface StandardPhoneNumberProps {
  value: string;
  disabled?: boolean;
  className: string;
  onChange: (value: string) => void;
  showError?: boolean;
  placeholder?: string;
  validations?: ValidationObj[];
  label: string;
}

const StandardPhoneNumber = (props: StandardPhoneNumberProps) => {
  const onChange = (value: any) => {
    props.onChange(value);
  };

  const generateValue = () => {
    if (!props.value) {
      return '';
    }

    if (props.value && props.value.startsWith('+')) {
      return props.value;
    } else {
      return `+${props.value}`;
    }
  };

  useEffect(() => {
    const input = document.querySelector(
      '.PhoneInputInput'
    ) as HTMLInputElement;
    const countrySelect = document.querySelector(
      '.PhoneInputCountrySelect'
    ) as HTMLInputElement;

    if (input) {
      input.classList.add('form-control');
    }

    if (countrySelect) {
      countrySelect.classList.add('d-none');
    }
  }, []);
  return (
    <Fragment>
      <div className="capitalize fs-14">
        {capitalizeFirstLetter(props.label)}
      </div>
      <PhoneInput
        className={`${props.className}`}
        value={generateValue()}
        disabled={props.disabled}
        onChange={onChange}
        placeholder={props.placeholder}
      />
    </Fragment>
  );
};

export default StandardPhoneNumber;
